<div class="dialog-container">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
        <p [innerHTML]="data.text"></p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
    </div>
</div>
